import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------AI问答相关接口---------------------------- */

  //AI会话-发送消息
  answerSendText(data) {
    return request({
      url: `${resquest}/novel/app/dialogue/async/v4`,
      method: 'post',
      data: data
    })
  },
  //AI会话-详情
  answerDetail(params) {
    return request({
      url: `${resquest}/novel/app/dialogue/content`,
      method: 'get',
      params: params
    })
  },
  //AI会话-创建会话
  answerCreate(params) {
    return request({
      url: `${resquest}/novel/app/dialogue/create`,
      method: 'get',
      params: params
    })
  },
  //AI会话-删除会话
  answerDel(data) {
    return request({
      url: `${resquest}/novel/app/dialogue/delete`,
      headers: {
        "Content-Type": 'multipart/form-data'
      },
      method: 'post',
      data: data
    })
  },
  //问答记录
  answerHistoryList(params) {
    return request({
      url: `${resquest}/novel/app/dialogue/list`,
      method: 'get',
      params
    })
  },
  //文件上传
  updateFiles(data) {
    return request({
      url: `${resquest}/novel/app/dialogue/upload`,
      headers: {
        "Content-Type": 'multipart/form-data'
      },
      method: 'post',
      data
    })
  }
}